(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-selling"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBSP(section) {
    var carousel = section.querySelector('[data-bsp-carousel]');
    var track    = section.querySelector('[data-bsp-track]');
    var cards    = section.querySelectorAll('[data-bsp-card]');
    var dots     = section.querySelectorAll('[data-bsp-dot]');
    if (!track || !carousel) return;

    var index  = 0;
    var total  = cards.length;
    var startX = null;
    var dragDx = 0;
    var isDrag = false;

    function go(i) {
      if (window.innerWidth >= 990) { return; }
      index = Math.max(0, Math.min(i, total - 1));
      var card   = cards[0];
      var gap    = parseFloat(getComputedStyle(track).gap) || 10;
      var offset = index * (card.offsetWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      dots.forEach(function (d, di) {
        var on = di === index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    carousel.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 32) { dx < 0 ? go(index + 1) : go(index - 1); }
      startX = null;
    }, { passive: true });

    carousel.addEventListener('mousedown', function (e) {
      isDrag = true; dragDx = 0; startX = e.clientX;
      carousel.classList.add('is-dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) { if (isDrag) dragDx = e.clientX - startX; });
    window.addEventListener('mouseup', function () {
      if (!isDrag) return;
      isDrag = false;
      carousel.classList.remove('is-dragging');
      if (Math.abs(dragDx) > 32) { dragDx < 0 ? go(index + 1) : go(index - 1); }
    });

	    section.querySelectorAll('[data-bsp-like]').forEach(function (btn) {
	      btn.addEventListener('click', function (e) {
	        e.stopPropagation();
	        var liked = btn.classList.toggle('is-liked');
	        var path  = btn.querySelector('path');
	        if (path) path.setAttribute('fill', liked ? 'currentColor' : 'none');
	        btn.setAttribute('aria-label', liked ? 'Remove from wishlist' : 'Add to wishlist');
	      });
	    });

	    function waitForShopflo(maxWait) {
	      var interval = 100;
	      var waited = 0;
	      return new Promise(function (resolve) {
	        function check() {
	          if (typeof window.handleFloCartBtn === 'function') {
	            resolve(true);
	            return;
	          }
	          waited += interval;
	          if (waited >= maxWait) {
	            resolve(false);
	            return;
	          }
	          window.setTimeout(check, interval);
	        }
	        check();
	      });
	    }

	    section.querySelectorAll('.bsp-atc-form').forEach(function (form) {
	      if (form.dataset.bspShopfloBound === 'true') return;
	      form.dataset.bspShopfloBound = 'true';

	      form.addEventListener('submit', function (event) {
	        event.preventDefault();

	        var button = form.querySelector('.bsp-atc');
	        var previousHtml = button ? button.innerHTML : '';

	        if (button) {
	          button.disabled = true;
	          button.setAttribute('aria-busy', 'true');
	          button.innerHTML = 'Adding...';
	        }

	        fetch('/cart/add.js', {
	          method: 'POST',
	          headers: { 'Accept': 'application/json' },
	          body: new FormData(form)
	        })
	          .then(function (response) {
	            if (!response.ok) throw new Error('Best seller add to cart failed');
	            return response.json();
	          })
	          .then(function () {
	            return waitForShopflo(5000);
	          })
	          .then(function (shopfloReady) {
	            if (shopfloReady) {
	              window.setTimeout(function () {
	                window.handleFloCartBtn();
	              }, 250);
	            } else {
	              window.location.href = '/cart';
	            }
	          })
	          .catch(function () {
	            form.submit();
	          })
	          .finally(function () {
	            if (button) {
	              button.disabled = false;
	              button.removeAttribute('aria-busy');
	              button.innerHTML = previousHtml;
	            }
	          });
	      });
	    });

	    var shareToast = section.querySelector('[data-bsp-share-toast]');
	    var shareToastTimer = null;

	    function showShareToast() {
	      if (!shareToast) return;

	      shareToast.classList.add('is-visible');
	      window.clearTimeout(shareToastTimer);
	      shareToastTimer = window.setTimeout(function () {
	        shareToast.classList.remove('is-visible');
	      }, 2200);
	    }

	    function copyProductLink(url) {
	      if (navigator.clipboard && window.isSecureContext) {
	        return navigator.clipboard.writeText(url);
	      }

	      return new Promise(function (resolve, reject) {
	        var input = document.createElement('textarea');
	        input.value = url;
	        input.setAttribute('readonly', '');
	        input.style.position = 'fixed';
	        input.style.top = '-9999px';
	        document.body.appendChild(input);
	        input.select();

	        try {
	          document.execCommand('copy');
	          resolve();
	        } catch (error) {
	          reject(error);
	        } finally {
	          document.body.removeChild(input);
	        }
	      });
	    }

	    section.querySelectorAll('[data-bsp-share]').forEach(function (btn) {
	      if (btn.dataset.bspShareBound === 'true') return;
	      btn.dataset.bspShareBound = 'true';

	      btn.addEventListener('click', function (event) {
	        event.preventDefault();
	        event.stopPropagation();

	        var url = btn.getAttribute('data-share-url') || window.location.href;
	        if (url === '#') url = window.location.href;

	        copyProductLink(url)
	          .then(showShareToast)
	          .catch(showShareToast);
	      });
	    });
	
	    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { go(index); }, 100);
    }, { passive: true });

    go(0);
  }

  function initAll() { document.querySelectorAll('.bsp-section').forEach(initBSP); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('.bsp-section') : null;
    if (s) initBSP(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
     
class FilpClock extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute('data-countdown-input')).getTime();
    this.flipclock = this.querySelectorAll('[data-flip-clock]');
    this.timer_labels = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    var time = this.timeDifference(currentDate, this.targetDate);
    if (this.remainingTime <= 0) {

       const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
    }
    
   
   
    if ('IntersectionObserver' in window === false) return;
    const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initializeClock();
          observer.unobserve(this);
        }
    });
    }, { rootMargin: '0px 0px 700px 0px' });
    observer.observe(this);


    this.flipclock.forEach((flipClock) => { 
  var daysFirst = flipClock.querySelector('[data-days-first]');
  var hoursFirst = flipClock.querySelector('[data-hours-first]');
  var minutesFirst = flipClock.querySelector('[data-minutes-first]');
  var secondsFirst = flipClock.querySelector('[data-seconds-first]');


  if (daysFirst) {
    daysFirst.querySelector('[data-day]').value = time.days;
    daysFirst.querySelectorAll('[data-day-top]').forEach((element) => {
      element.textContent = time.days; 
    });
    daysFirst.querySelectorAll('[data-day-bottom]').forEach((element) => {
      element.textContent = time.days; 
    });
  }

  if (hoursFirst) {
    hoursFirst.querySelector('[data-hour]').value = time.hours;
    hoursFirst.querySelectorAll('[data-hour-top]').forEach((element) => {
      element.textContent = time.hours; 
    });
    hoursFirst.querySelectorAll('[data-hour-bottom]').forEach((element) => {
      element.textContent = time.hours; 
    });
  }

  if (minutesFirst) {
    minutesFirst.querySelector('[data-minute]').value = time.minutes;
    minutesFirst.querySelectorAll('[data-minute-top]').forEach((element) => {
      element.textContent = time.minutes; // Update top text for minutes
    });
    minutesFirst.querySelectorAll('[data-minute-bottom]').forEach((element) => {
      element.textContent = time.minutes; // Update bottom text for minutes
    });
  }

  if (secondsFirst) {
    secondsFirst.querySelector('[data-second]').value = time.seconds;
    secondsFirst.querySelectorAll('[data-second-top]').forEach((element) => {
      element.textContent = time.seconds; // Update top text for seconds
    });
    secondsFirst.querySelectorAll('[data-second-bottom]').forEach((element) => {
      element.textContent = time.seconds; // Update bottom text for seconds
    });
  }

});


  }

  initializeClock() {
  this.flipclock.forEach((flipClock) => { // Changed function to arrow function

    var daysFirst = this.createHandles(flipClock.querySelector('[data-days-first]'));
    var hoursFirst = this.createHandles(flipClock.querySelector('[data-hours-first]'));
    var minutesFirst = this.createHandles(flipClock.querySelector('[data-minutes-first]'));
    var secondsFirst = this.createHandles(flipClock.querySelector('[data-seconds-first]'));

    function updateClock() {
      var time = this.timeDifference(currentDate, this.targetDate); // Ensure 'this' refers to FilpClock instance
    

      this.flipDigit(daysFirst, Math.floor(time.days));

      this.flipDigit(hoursFirst, Math.floor(time.hours ));

      this.flipDigit(minutesFirst, Math.floor(time.minutes));
      this.flipDigit(secondsFirst, Math.floor(time.seconds));
   
      this.querySelector('[data-day]').value = time.days;
      this.querySelector('[data-hour]').value = time.hours;
      this.querySelector('[data-minute]').value = time.minutes;
      this.querySelector('[data-second]').value = time.seconds;
      
      if (time.total <= 0) {
        const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
      
        clearInterval(timeinterval);
      }
    }
    var currentDate = new Date().getTime(); // Define currentDate here
    var timeinterval = setInterval(updateClock.bind(this), 1000); // Bind updateClock to FilpClock instance
    });
  }


  timeDifference(current, target) {
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    return {
      'total': this.remainingTime,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  createHandles(flipElement) {
    var flipperTop = flipElement.querySelector("[flipper-top]");
    var flipperBottom = flipElement.querySelector("[flipper-bottom]");
    var flipperDisplayTop = flipElement.querySelector("[flip-display-top]");
    var flipperDisplayBottom = flipElement.querySelector("[flip-display-bottom]");
    var flipHiddenInput = flipElement.querySelector("[type='hidden']");
    return {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    };
  }

  flipDigit(flipHandles, digitValue) {
    var {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    } = flipHandles;

    var setPreviousValue = function(value) {
      flipperTop.innerText = value;
      flipperDisplayBottom.innerText = value;
    };
    var setAfterValue = function(value) {
      flipperDisplayTop.innerText = value;
      flipperBottom.innerText = value;
    };

    if (parseInt(flipHiddenInput.value) !== digitValue) {
      setPreviousValue(flipHiddenInput.value);
      flipHiddenInput.value = digitValue;
      var valueChangedEvent = new Event('valueChanged');
      flipHiddenInput.dispatchEvent(valueChangedEvent);
    }

    flipHiddenInput.addEventListener('valueChanged', function() {
      setAfterValue(flipHiddenInput.value);
      flipElement.classList.add("play");
    });

    flipperBottom.addEventListener('animationend', function() {
      setAfterValue(flipHiddenInput.value);
      setPreviousValue(flipHiddenInput.value);
      flipElement.classList.remove("play");
    });
  }
}
customElements.define('filpclock-counter', FilpClock);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
     
class FeatureProducts extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const currentSection = this.closest('.shopify-section');
    const offsetSection = currentSection.getBoundingClientRect();

    if (offsetSection.top < window.innerHeight && offsetSection.bottom > 70) {
      this.classList.add('is-active');
    }
  }
}

customElements.define('feature-products', FeatureProducts);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-glp"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.style.setProperty('--progress_width', `${parseInt(this.dataset.value) * 0.75 * 100 / parseInt(this.dataset.max)}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.style.setProperty('--progress_width', `${parseInt(this.dataset.value) * 0.75 * 100 / parseInt(this.dataset.max)}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-bar"] && !Shopify.designMode) return;
  try {
    
  class PromotionalBar extends HTMLElement {
    constructor() {
      super();

      const popupModal = this.querySelector('popup-modal');

      this.videos = this.querySelectorAll('[promotional-bar-video]');

      this.videos.forEach((video) => {
        video.addEventListener('click', () => {
          const videoId = video.getAttribute('data-id');
          console.log(videoId);
          popupModal.modalPopupOpen(`data-video-popup-${videoId}`);
        });
      });
    }
  }

  customElements.define('promotional-bar', PromotionalBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
     
class Textwithicon extends HTMLElement{
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(this.getHeight.bind(this));
    resizeObserver.observe(this);
    //this.getHeight();
  }
  getHeight(){
    this.divElement = this.querySelectorAll("[data-text-icon-desc]");
    this.divElement.forEach(element => {
      this.elemHeight = element.getBoundingClientRect().height;
      let closestParent = element.closest('[data-text-icon-inner]');
      if (closestParent) {
    
        closestParent.style.setProperty('--description_height', `${this.elemHeight}px`);
      }
    });
  }
}
customElements.define('text-with-icon', Textwithicon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
     
class AnimatedCursor extends HTMLElement {
  constructor() {
    super();

    this.mouse = { x: -100, y: -100 };
    this.pos = { x: 0, y: 0 };
    this.speed = 0.15;
    this.element = null; // Keep track of the current element with cursor class

    
    //window.addEventListener('mousedown', this.startDrag.bind(this));
   // window.addEventListener('mouseup', this.endDrag.bind(this));

    const cursorPointer = this.closest('.section-video');

    if(! cursorPointer){ 
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));  
        return; 
      }
    // window.addEventListener('mousedown', this.startDrag.bind(this));
    cursorPointer.querySelectorAll('[cursor-class]').forEach((cursorModifier) => {
     cursorModifier.addEventListener('pointermove', this.updateCoordinates.bind(this));
      cursorModifier.addEventListener('mouseenter', this.addCursorClass.bind(this));
      cursorModifier.addEventListener('mouseleave', this.removeCursorClass.bind(this));
      cursorModifier.addEventListener('mouseout', this.removeCursor.bind(this));
      cursorModifier.addEventListener('scroll', () => {
        console.log('Scroll event fired');
      });
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));
      cursorModifier.addEventListener('mouseup', this.endDrag.bind(this));
      cursorModifier.addEventListener('mousedown', this.startDrag.bind(this)); // Add mousedown event here
    });

    requestAnimationFrame(this.loop.bind(this));
  }

  startDrag(e) {
    this.updateCoordinates(e);
  }

  endDrag(e) {
    this.updateCoordinates(e);
  }

  removeCursor(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    this.elementName = event.target.tagName;
  }

  handleScroll(e){
    console.log("wqewqe");
  }
  updateCoordinates(e) {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  }

  getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
  }

  getSqueeze(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    const maxSqueeze = 0.0;
    const accelerator = 1500;
    return Math.min(distance / accelerator, maxSqueeze);
  }

  updateCursor() {
    const diffX = Math.round(this.mouse.x - this.pos.x);
    const diffY = Math.round(this.mouse.y - this.pos.y);

    this.pos.x += diffX * this.speed;
    this.pos.y += diffY * this.speed;

    const angle = this.getAngle(diffX, diffY);
    const squeeze = this.getSqueeze(diffX, diffY);

    // Update cursor style with transformations
    this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
    //this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg) translate3d(${this.pos.x}px, ${this.pos.y}px, 0)`;
  }

  loop() {
    this.updateCursor();
    requestAnimationFrame(this.loop.bind(this));
  }

  addCursorClass(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    if (className === 'video') {
      this.classList.add('king_cursor');
      this.videoButton = this.element.querySelector('[data-content-button]');
     
      if(this.videoButton){
      this.videoButton.style.display = "none";
      }
      this.innerHTML = this.videoButton.innerHTML;
    }
  }

  removeCursorClass(event) {
    const element = event.currentTarget;
    console.log(element);
    const className = element.getAttribute('cursor-class');
    if (className === 'video') {
      this.videoButton = this.element.querySelector('[data-content-button]');
      if(this.videoButton){
      this.videoButton.style.display = "block";
      }
      this.innerHTML = '';
      this.classList.remove('king_cursor');
    }
  }
}

customElements.define('animated-cursor', AnimatedCursor);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-to"] && !Shopify.designMode) return;
  try {
    
  (function () {
	    function initAccordion(root) {
	      var cards = root.querySelectorAll('[data-wte-card]');
	      if (!cards.length) return;
	
	      var suppressHoverUntil = 0;

	      function setCardStates(activeCard) {
	        var activeIndex = Array.prototype.indexOf.call(cards, activeCard);
	        cards.forEach(function (card, index) {
	          card.classList.toggle('is-before', index < activeIndex);
	          card.classList.toggle('is-after', index > activeIndex);
	        });
	      }
	
	      function expand(card) {
	        cards.forEach(function (c) {
	          var isThis = c === card;
	          c.classList.toggle('is-expanded', isThis);
	          c.setAttribute('aria-expanded', isThis ? 'true' : 'false');
	        });
	        setCardStates(card);
	        suppressHoverUntil = Date.now() + 500;
	        if (card.scrollIntoView) {
	          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
	        }
	      }

	      var initialCard = root.querySelector('[data-wte-card].is-expanded') || cards[0];
	      if (initialCard) setCardStates(initialCard);

      cards.forEach(function (card) {
        card.addEventListener('click', function () { expand(card); });
      });

      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover) {
        var hoverTimer;
        cards.forEach(function (card) {
          card.addEventListener('mouseenter', function () {
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () {
              if (Date.now() < suppressHoverUntil) return;
              expand(card);
            }, 220);
          });
          card.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
        });
      }
    }

    function initTestCarousel(root) {
      var viewport = root.querySelector('[data-wte-test-viewport]');
      var track = root.querySelector('[data-wte-test-track]');
      var slides = root.querySelectorAll('[data-wte-test-slide]');
      var dots = root.querySelectorAll('[data-wte-test-dot]');
      var prevBtn = root.querySelector('[data-wte-test-prev]');
      var nextBtn = root.querySelector('[data-wte-test-next]');
      if (!track || slides.length < 2) return;

      var index = 0;
      var autoplaySeconds = parseFloat(root.getAttribute('data-autoplay')) || 5;
      var timer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        slides.forEach(function (s, si) {
          s.setAttribute('aria-hidden', si === index ? 'false' : 'true');
          if (si !== index) {
            s.querySelectorAll('video').forEach(function (video) { video.pause(); });
          }
        });
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === index);
          d.setAttribute('aria-selected', di === index ? 'true' : 'false');
        });
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      function play() {
        stop();
        if (reduceMotion) return;
        timer = setInterval(next, autoplaySeconds * 1000);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); play(); });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });

      var startX = null;
      viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
        startX = null;
        play();
      }, { passive: true });

      viewport.addEventListener('mouseenter', stop);
      viewport.addEventListener('mouseleave', play);

      root.querySelectorAll('.wte-test__video').forEach(function (video) {
        video.addEventListener('play', stop);
        video.addEventListener('pause', play);
        video.addEventListener('ended', play);
      });

      go(0);
      play();
    }

    function initAll() {
      document.querySelectorAll('.wte-section').forEach(function (root) {
        initAccordion(root);
        initTestCarousel(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.wte-section') : null;
      if (root) { initAccordion(root); initTestCarousel(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
